module.exports = __webpack_public_path__ + "account/assets/oops-rhino.80d3605a.svg";